<style>
#product{
	height:calc(100vh - 128px)!important;
	padding:30px 30px 8px 30px;
}
#product .q-tab__label {
	font-size: 1rem;
    font-weight: bold;
}
#product .q-tab-panels{
	height:calc(100% - 48px)!important;
}
#product .q-table__middle{
	overflow-y: hidden !important;
	overflow-x: auto !important;
	height:calc(100% - 48px)!important;
	width: 100%;
}
#product .q-table{/*-horizontal-separator*/
	overflow: hidden !important;
	height:100% !important;
	width: 100%;
}
#product .q-table thead{
	height:48px;
	display: block;
}
#product tbody{
	display: block;
	height:100%;
	max-height: calc(100vh - 300px);;
	width: 100%;
	overflow: auto;
	webkit-overflow-scrolling: touch;
	will-change: scroll-position;
}
#product .q-table thead tr, #product .q-table tbody tr{
	width: 100%;
	display: table;
}
#product .q-table__bottom{
	position: absolute;
	bottom: 0;
	width: 100%;
}
</style>
<template>
  <q-page id="product" padding :style="{padding:screenType?'30px 30px 8px 30px!important':'8px'}">
  	<q-card class="fit">
		<q-card-section style="height: 60px;padding:10px 15px;">
			<q-input v-model="keyword" @keyup.enter="getData(1)" :placeholder="$t('key')" maxlength="15" style="width:210px;float:right;" rounded outlined dense >
			  <template v-slot:after>
			    <q-btn @click="getData(1)" icon="fa fa-search" color="white" text-color="primary" round dense />
			  </template>
			</q-input>
		</q-card-section>
		<q-separator />
        <q-card-section class="q-pa-none" style="height:calc(100% - 60px);width: 100%">
			<q-table class="fit" :data="listData" :columns="columns" :loading="loading" :pagination.sync="page" :rows-per-page-options="[15,20,30]" row-key="id">
				<tr slot="header" slot-scope="props">
					<q-th key="id" :props="props" style="width:7%;min-width: 50px">ID</q-th>
					<q-th key="name" :props="props" style="width:22%;min-width: 300px">{{$t('name')}}</q-th>
					<!-- <q-th key="module" :props="props" style="width:20%;">{{$t('product.model')}}</q-th> -->
					<q-th key="serial" :props="props" style="width:18%;min-width: 200px">{{$t('num')}}</q-th>
					<q-th key="type" :props="props" style="width:20%;min-width: 200px">{{$t('type')}}</q-th>
					<q-th key="customerName" :props="props" style="width:20%;min-width: 200px">{{$t('customer.name')}}</q-th>
					<!-- <q-th key="address" :props="props" style="width:17%;">{{$t('address')}}</q-th> -->
					<q-th key="opt" :props="props" style="width:13%;min-width:135px;">{{$t('opt')}}</q-th>
				</tr>
				<q-tr slot="body" slot-scope="props" :props="props">
					<!--<q-td key="id" :props="props" style="width:7%;">{{ props.row.__index+1 }}</q-td>-->
					<q-td key="id" :props="props" style="width:7%;min-width: 50px">{{ props.row.id }}</q-td>
					<q-td key="name" :props="props" style="width:22%;min-width: 300px">{{ props.row.name }}</q-td>
					<!-- <q-td key="module" :props="props" style="width:20%;">{{ props.row.module }}</q-td> -->
					<q-td key="serial" :props="props" style="width:18%;min-width: 200px">{{ props.row.serial }}</q-td>
					<q-td key="type" :props="props" style="width:20%;min-width: 200px">{{props.row.productType&&props.row.productType.name?props.row.productType.name:''}}</q-td>
					<q-td key="customerName" :props="props" style="width:20%;min-width: 200px">{{props.row.customerName?props.row.customerName:''}}</q-td>
					<!-- <q-td key="address" :props="props" style="width:17%;">{{ props.row.address }}</q-td> -->
					<q-td key="opt" :props="props" style="width:13%;min-width:135px;">
						<q-btn @click="btnClick(0,props.rowIndex)" icon="fa fa-search" color="primary" size="sm" flat round dense><!-- :color="color1[id%10]" -->
							<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('detail')}}</q-tooltip>
						</q-btn>
						<q-btn @click="btnClick(1,props.rowIndex)" icon="fa fa-list" color="positive" size="sm" flat round dense class="q-ml-sm">
							<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('product.dialog[1]')}}</q-tooltip>
						</q-btn>
						<q-btn @click="btnClick(props.row.customerName?3:2,props.rowIndex)" :icon="props.row.customerName?'fa fa-user-times':'fa fa-user-plus'" :color="props.row.customerName?'red':'amber-7'" size="sm" flat round dense class="q-ml-sm">
							<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{props.row.customerName?$t('product.dialog[3]'):$t('product.dialog[2]')}}</q-tooltip>
						</q-btn>
					</q-td>
				</q-tr>
				<div slot="pagination" slot-scope="props" class="row flex-center q-py-sm">
					<q-btn @click="pageClick(0)" :disable="curPage<=1" icon="fas fa-arrow-left" color="primary" size="sm" round dense/>
					<div class="q-mx-md" style="font-size: small"> {{ curPage }} / {{ totalPage }} </div>
					<q-btn @click="pageClick(1)" :disable="nextPage" icon="fas fa-arrow-right" color="primary" size="sm" round dense/>
				</div>
			</q-table>
        </q-card-section>
  	</q-card>

	<q-dialog v-model="dialogStatus" persistent transition-show="scale" transition-hide="scale">
		<q-card :class="[screenType?'q-pa-lg':'q-pa-sm']" :style="{minWidth:screenType?'450px':'85vw',width:screenType?'':'65vw'}">
	    <q-card-section><div class="text-h6">{{$t('product.dialog')[dialogType]}}</div></q-card-section>
	    <q-card-section class="fit scroll" style="max-height:60vh;">
	      <div v-if="dialogType===2">
			  <q-select ref="customer" v-model="form.customer" :label="$t('customer.dialog[3]')" option-value="id" option-label="customerName" :options="customerOpt" emit-value map-options outlined
			  	:rules="[val => !!val || $t('msg.select'),]" use-input input-debounce="0" @filter="customFilter" />
	      </div>
		  <div v-if="dialogType===1">
			  <q-list v-if="form.deviceList&&form.deviceList.length>0" separator bordered>
				  <q-item v-for="(item,index) in form.deviceList" :key="index" clickable>
					  <q-item-section>
						  <q-item-label>{{item.name}}</q-item-label>
					  </q-item-section>
					  <q-item-section side>
					    <q-item-label caption>{{item.type}}</q-item-label>
					  </q-item-section>
				  </q-item>
			</q-list>
			<div v-else>{{$t('null')}}</div>
		  </div>
		  <div v-if="dialogType===0" style="line-height:38px;font-size:15px;margin:0 auto;">
		  		<q-field borderless>
		  			<template v-slot:prepend><span style="font-size:15px;">{{$t('name')}}：</span></template>
		  			<template v-slot:control>
		  				<div class="self-center full-width no-outline" tabindex="0">{{form.name}}</div>
		  			</template>
		  		</q-field>
				<q-field borderless>
					<template v-slot:prepend><span style="font-size:15px;">{{$t('customer.name')}}：</span></template>
					<template v-slot:control>
						<div class="self-center full-width no-outline" tabindex="0">{{form.customerName}}</div>
					</template>
				</q-field>
				<q-field borderless>
					<template v-slot:prepend><span style="font-size:15px;">{{$t('product.model')}}：</span></template>
					<template v-slot:control>
						<div class="self-center full-width no-outline" tabindex="0">{{form.moduleId}}</div>
					</template>
				</q-field>
		  		<q-field borderless>
		  			<template v-slot:prepend><span style="font-size:15px;">{{$t('num')}}：</span></template>
		  			<template v-slot:control>
		  				<div class="self-center full-width no-outline" tabindex="0">{{form.serial}}</div>
		  			</template>
		  		</q-field>
		  		<q-field borderless>
		  			<template v-slot:prepend><span style="font-size:15px;">{{$t('type')}}：</span></template>
		  			<template v-slot:control>
		  				<div class="self-center full-width no-outline" tabindex="0">{{form.productType&&form.productType.name?form.productType.name:$t('null')}}</div>
		  			</template>
		  		</q-field>
				<q-field borderless>
					<template v-slot:prepend><span style="font-size:15px;">{{$t('address')}}：</span></template>
					<template v-slot:control>
						<div class="self-center full-width no-outline" tabindex="0">{{form.address}}</div>
					</template>
				</q-field>
		  		<q-field borderless>
		  			<template v-slot:prepend><span style="font-size:15px;">{{$t('createTime')}}：</span></template>
		  			<template v-slot:control>
		  				<div class="self-center full-width no-outline" tabindex="0">{{form.createTime |parseDateTime}}</div>
		  			</template>
		  		</q-field>
		  		<q-field borderless>
		  			<template v-slot:prepend><span style="font-size:15px;">{{$t('updateTime')}}：</span></template>
		  			<template v-slot:control>
		  				<div class="self-center full-width no-outline" tabindex="0">{{form.updateTime |parseDateTime}}</div>
		  			</template>
		  		</q-field>
		  </div>
	    </q-card-section>
	    <q-card-actions align="right" class="bg-white text-teal">
	    	<q-btn :label="$t('close')" :flat="dialogType===2" color="primary" class="q-mr-md" v-close-popup/>
	    	<q-btn v-if="dialogType===2" @click="confirm()" :label="$t('ok')" :disable="btnDisable" icon="fas fa-check" color="primary"/>
	    </q-card-actions>
	  </q-card>
	</q-dialog>

  </q-page>
</template>
<script>
var customerOpt = [];
export default {
  data (){
  	return{
		keyword:null,
  		color1:COLOR_Q,
  		colors:COLOR_THEME,
  		//loadIcon:[], loadData:[],
  		filter: '',
		selected: 0,
		total:0,
		curPage:1,
		page:{ page:1, rowsPerPage:20 },
		loading:false,
		columns: [{ name: 'id', field: 'id', align: 'left', sortable:true},
        { name: 'name', field: 'name', align: 'left'},
        //{ name: 'module', field: 'module', align: 'left', sortable: true },
        { name: 'serial', field: 'serial', align: 'left', sortable: true },
        { name: 'type', field: 'type', align: 'left', },
		{ name: 'customerName', field: 'customerName', align: 'left'},
        //{ name: 'address', field: 'address', align: 'left'},
        { name: 'opt', field: 'opt', align: 'left'},
		],
		data: ['广告屏','灯杆'],
		listData:[],
		customerOpt:[],
		dialogStatus:false,
		dialogType:0,
		content:{ customer:null, },
		form:{},
		btnDisable:false,
  	}
  },
  props:['lang'],
  filters: {
    	parseDateTime(time){
    		return time?parseDateTime(time):time;
    	}
    },
  watch:{
  	lang(val, oldVal){
    	this.columns = this.columns;
    },
    pageCount(val, oldVal){//选每页数量 size
    	if(val){
    		this.curPage = 1;
    		this.getData(this.curPage);
    	}
    },
  },
	computed: {
			screenType() {
      return _isPC(); //this.$q.platform.is.desktop
    },
		nextPage(){
			return this.curPage>=Math.ceil(this.total/this.page.rowsPerPage);
		},
		totalPage(){
			return Math.ceil(this.total/this.page.rowsPerPage);
		},
		pageCount(){
			return this.page.rowsPerPage;
		}
	},
  created(){
  	this.form = JSON.parse(JSON.stringify(this.content));
  	if(localStorage.getItem("AS_token") && localStorage.getItem("AS_token").length>0) {
		this.getCustomer();
  		this.getData(1);
  	}else{
  		this.$router.replace('/');//login
  	}
  },
  methods: {
	customFilter(val, update) {
	  if (val === '') {
	    update(() => { this.customerOpt = customerOpt }); //return
	  }else{
		 update(() => {
		   var value = val.toLowerCase();
		   this.customerOpt = customerOpt.filter(v => v.name.toLowerCase().indexOf(value) > -1)
		 })
	  }
	},
	openDialog(type){
		this.dialogType = type;
		this.dialogStatus = true;
	},
	getCustomer(){//获取客户列表
		var request = {};
		request.paging = { index:0, count:-1, sort:'desc' };
		this.$ajax(1,'post',true,'/customer/list',request).then((res)=>{
			if(res&&res.data){
				customerOpt = res.data;
				this.customerOpt = res.data;
			}
		}).catch((err)=>{
			console.log(err)
			this.$emit('islogin',0,err);
		})
	},
	getData(index){
		this.listData = [];
		this.loading = true;
		var request = {};
		//request.ids = [];
		if(this.keyword) request.keyword = this.keyword;
		request.paging = { index:(index-1)*this.page.rowsPerPage, count:this.page.rowsPerPage, sort:'desc' };
		this.$ajax(1,'post',true,'/product/list',request).then((res)=>{
			if(res&&res.data){
				// this.listData = res.data;
				// 排序 property 根据对象某个属性排
				function compare(property){
    				return function(a,b){
        				var value1 = a[property];
        				var value2 = b[property];
        				return value2 - value1;
    				}
				}
				this.listData = res.data.sort(compare('id'))
				this.total = res.paging.total;
			}
			setTimeout(() => { this.loading = false }, 800);
		}).catch((err)=>{
			console.log(err)
			setTimeout(() => { this.loading = false }, 800);
			this.$emit('islogin',index==1?0:1,err);
			//if(err.code) this.$notify(2,err.msg,null);
		})
	},
	btnClick(type,index){
		if(type===0||type===1){//详情/列表
			this.form = JSON.parse(JSON.stringify(this.listData[index]));
			var tempName = JSON.parse(JSON.stringify(this.form.customerName));
			//var request = {};
			//request.serverId = 3;request
			this.$ajax(1,'get',true,'/product/'+this.form.id,null).then((res)=>{
				if(res&&res.data){
					this.form = res.data;
					this.$set(this.form,'customerName',tempName);
				}
				this.openDialog(type);
			}).catch((err)=>{ this.openDialog(type); })
		}else if(type===2){//分配
			this.form = JSON.parse(JSON.stringify(this.listData[index]));
			this.openDialog(type);
		}else if(type===3){//移除分配
  			this.$ajax(1,'get',true,'/customer/findCustomerByProductId/'+this.listData[index].id,null).then((res)=>{
  				if(res&&res.data&&res.data.id){
					this.$q.dialog({
						title: this.$t('msg.prompt'),
						message: this.$t('product.msg_remove'),
						persistent: true,
						cancel: true,
					}).onOk((result) => {
						var request = {};
						request.productId = [this.listData[index].id];
						//request.customerId = res.data.id;
						this.$ajax(1,'post',true,'/product/deleteProductForCustomer',request).then((res)=>{
							this.getData(this.curPage);
							this.$notify(1,this.$t('product.ok_remove'),null);
						}).catch((err)=>{
							console.log(err)
							this.$emit('islogin',1,err);
							//if(err.code) this.$notify(2,err.msg,null);
						})
					}).onCancel((err) => { })
				}
  			}).catch((err)=>{ })
  		}
	},
	confirm(){
		if(this.dialogType==2){//更新分配
			this.$refs.customer.validate();
			if (this.$refs.customer.hasError) {
				this.$notify(2,this.$t('msg.input_err'),null);
				return
			}else{
				this.btnDisable = true;
				var request = {};
				request.productId = [this.form.id];
				request.customerId = this.form.customer;
				this.$ajax(1,'post',true,'/product/assignProductTheCustomer',request).then((res)=>{
					this.getData(this.curPage);
					this.dialogStatus = false;
					this.btnDisable = false;
					this.$notify(1,this.$t('product.ok_assgin'),null);
				}).catch((err)=>{
					console.log(err)
					this.$emit('islogin',1,err);
					this.btnDisable = false;
					//if(err.code) this.$notify(2,err.msg,null);
				})
			}
		}
	},
	pageClick(type){//点击页数 type:0-,1+
		this.curPage= type? this.curPage+1:this.curPage-1;
		if(this.curPage>0&&this.total!==0&&this.listData.length<this.total){
			this.getData(this.curPage);
		}
	},
  }
}
</script>
